import { atom } from 'jotai'

// 住戸一覧は状態管理が複雑になるため、他テーブルのようにPropsのバケツリレーは極力行わずstoreで管理する

type SelectedHeadSelectMasterCell = { key: 'headSelectMaster'; selectMasterId: string }
type SelectedRoomSelectMasterCell = {
  key: 'roomSelectMaster'
  roomId: string
  selectMasterId: string
}
type SelectedPreviewCell = { key: 'preview'; roomId: string }
type SelectedContractorCell = { key: 'contractor'; roomId: string }
type SelectedProxyRegisterCell = { key: 'proxyRegister'; roomId: string }
type SelectedContractorHistoriesCell = { key: 'contractorHistories'; roomId: string }
export type SelectedCellType =
  | SelectedHeadSelectMasterCell
  | SelectedRoomSelectMasterCell
  | SelectedPreviewCell
  | SelectedContractorCell
  | SelectedProxyRegisterCell
  | SelectedContractorHistoriesCell

type Input = {
  selectedRoomIds: string[] | undefined
  isShowAllRoomColumns: boolean
  isShowAllSelectMasterColumns: boolean
  isShowAllConstructorColumns: boolean
  selectedCell: SelectedCellType | undefined
}

const storeValues = atom<Input>({
  selectedRoomIds: undefined,
  isShowAllRoomColumns: true,
  isShowAllSelectMasterColumns: true,
  isShowAllConstructorColumns: true,
  selectedCell: undefined,
})
export const roomTableStore = { state: storeValues } as const
